import React from "react";
import '../assets/css/mainLayout.css';
import {  Outlet } from "react-router-dom";
import { Toaster } from 'react-hot-toast';
import { NotificationProvider } from "../components/common/NotificationProvider";

class MainLayout extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            height: window.innerHeight,
            maxView: false
        }
    }


    componentDidMount() {
        // this.onActiveRoute()
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }

    updateWindowDimensions = () => {
        this.setState({
            height: window.innerHeight
        })
    }

    handleMaximize = () => {
        this.setState({
            maxView: !this.state.maxView
        })
    }

    onActiveRoute = () => {
        const listItems = document.querySelectorAll('.list-item-route');

        // Add click event listener to each item
        listItems.forEach(item => {
            item.addEventListener('click', function () {
                // Remove the 'active' class from all items
                listItems.forEach(i => i.classList.remove('active'));

                // Add the 'active' class to the clicked item
                this.classList.add('active');
            });
        });
    }


    render() {
        return (
            <NotificationProvider>
            <div className="auth-layout">
                <Outlet />
                <Toaster />

            </div>
            </NotificationProvider>
        )
    }

}

export default MainLayout;